import { apiClient } from '@/services/apiClient';
import type { RequestOptions } from '@/services/apiClient';
import type { InvoiceDirection } from './financeInvoices.types';
import type {
  InvoiceActivityOptions,
  InvoiceActivitySource,
  InvoiceCommunicationPage,
} from './financeInvoiceEvidence.types';

const invoicePath = (direction: InvoiceDirection, id: string) =>
  `/v1/finance/command-center/invoices/${direction}/${encodeURIComponent(id)}`;

export const financeInvoiceEvidenceApi = {
  async list(direction: InvoiceDirection, id: string, page: number, options?: RequestOptions) {
    const result = await apiClient.get<InvoiceCommunicationPage>(
      `${invoicePath(direction, id)}/evidence?page=${page}&pageSize=1`,
      options,
    );
    if (!result.ok || !result.data)
      throw new Error(result.error ?? 'Invoice activity is unavailable.');
    return result.data;
  },
  async options(
    direction: InvoiceDirection,
    id: string,
    sourceType: InvoiceActivitySource,
    search: string,
    page: number,
    options?: RequestOptions,
  ) {
    const params = new URLSearchParams({
      kind: sourceType,
      search,
      page: String(page),
      pageSize: '2',
    });
    const result = await apiClient.get<InvoiceActivityOptions>(
      `${invoicePath(direction, id)}/communication-options?${params}`,
      options,
    );
    if (!result.ok || !result.data)
      throw new Error(result.error ?? 'Recorded activity options are unavailable.');
    return result.data;
  },
  async link(
    direction: InvoiceDirection,
    id: string,
    sourceType: InvoiceActivitySource,
    sourceId: string,
    options?: RequestOptions,
  ) {
    const result = await apiClient.post(
      `${invoicePath(direction, id)}/communications`,
      { kind: sourceType, sourceId },
      options,
    );
    if (!result.ok) throw new Error(result.error ?? 'The recorded activity could not be linked.');
    return result.data;
  },
  async unlink(direction: InvoiceDirection, id: string, linkId: string, options?: RequestOptions) {
    const result = await apiClient.delete(
      `${invoicePath(direction, id)}/communications/${encodeURIComponent(linkId)}`,
      options,
    );
    if (!result.ok)
      throw new Error(result.error ?? 'The invoice activity link could not be removed.');
    return result.data;
  },
};
